import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-2-line text-background-50 text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {t('common:siteName')}
              </h2>
            </Link>
            <p className="text-foreground-300 text-sm md:text-base leading-relaxed max-w-md">
              {t('common:footerBrandDesc')}
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-reddit-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-10 sm:gap-16 lg:gap-24">
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-foreground-400 mb-5">
                {t('common:footerAddress')}
              </h4>
              <p className="text-foreground-300 text-sm leading-relaxed">
                {t('common:footerAddressLine')}
              </p>
            </div>
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-foreground-400 mb-5">
                {t('common:footerPhone')}
              </h4>
              <p className="text-foreground-300 text-sm leading-relaxed">
                {t('common:footerPhoneLine')}
              </p>
            </div>
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-foreground-400 mb-5">
                {t('common:footerEmail')}
              </h4>
              <div className="flex flex-col gap-2 text-foreground-300 text-sm">
                <Link to="/category/action" className="hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">{t('common:navCategory')}</Link>
                <Link to="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">{t('common:navAbout')}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <small className="text-foreground-500 text-xs">
            {t('common:footerCopyright')}
          </small>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">
              {t('common:footerPrivacy')}
            </Link>
            <Link to="/about" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">
              {t('common:footerTerms')}
            </Link>
            <Link to="/about" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">
              {t('common:footerSitemap')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}